import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

export interface AlertProps {
    type: 'success' | 'error'
    text: string
}

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<AlertProps>();
    #keepAfterNavigationChange = false;
    #defaultDurationInMs = 8000

    constructor(private router: Router) {
        // clear alert message on route change
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.#keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.#keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next();
                }
            }
        });
    }

    success(message: string, keepAfterNavigationChange = false, duration: number = this.#defaultDurationInMs) {
        this.#keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
        setTimeout(() => this.dismiss(), duration)
    }

    error(message: string, keepAfterNavigationChange = false, duration: number = this.#defaultDurationInMs) {
        this.#keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
        setTimeout(() => this.dismiss(), duration)
    }

    getMessage(): Observable<AlertProps> {
        return this.subject.asObservable();
    }

    dismiss(): void {
        this.subject.next();
    }
}
